import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../services/analytics/posthogService';

/**
 * Every "Book a demo" button funnels through here: one PostHog `demo_button_clicked` with the
 * click source, then a navigation to the public `/book-demo` wizard. Replaces the old
 * DemoBookingModal, which every page had to import and keep open/close state for.
 */
export const useBookDemo = (source: string): (() => void) => {
  const navigate = useNavigate();

  return useCallback(() => {
    trackEvent('demo_button_clicked', { source });
    navigate('/book-demo');
  }, [navigate, source]);
};
